const PhoneVerificationModal = require('../accounts/PhoneVerificationModal.vue').default;

const elem = '#dashboard';
const DashboardPage = {
    el: elem,
    data: {
        open: false,
    },
    mixins: [],
	mounted() {},
    methods: {
        close: function () {
            this.open = false;
        }
    },
    computed: {},
    watch: {},
    components: {
        'phone-verification-modal': PhoneVerificationModal
    }
};

if ($(elem)) {
    new Vue(DashboardPage);
}
